var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1.5C1.34315 1.5 0 2.84315 0 4.5V19.5C0 21.1569 1.34315 22.5 3 22.5H21C22.6569 22.5 24 21.1569 24 19.5V4.5C24 2.84315 22.6569 1.5 21 1.5H3ZM7.5 21V3H21C21.8284 3 22.5 3.67157 22.5 4.5V19.5C22.5 20.3284 21.8284 21 21 21H7.5ZM3 3H6V21H3C2.17157 21 1.5 20.3284 1.5 19.5V4.5C1.5 3.67157 2.17157 3 3 3ZM16.8905 7.95555C17.1421 7.7399 17.1712 7.36112 16.9556 7.10953C16.7399 6.85793 16.3611 6.82879 16.1095 7.04445L10.8595 11.5444L10.328 12L10.8595 12.4556L16.1095 16.9556C16.3611 17.1712 16.7399 17.1421 16.9556 16.8905C17.1712 16.6389 17.1421 16.2601 16.8905 16.0444L12.172 12L16.8905 7.95555Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarClose);
export default __webpack_public_path__ + "static/media/sidebar-close.5ced813a0f214cb8dd57bcd5848f0b67.svg";
export { ForwardRef as ReactComponent };